import { render, staticRenderFns } from "./UserBind.vue?vue&type=template&id=21f3350d&scoped=true&"
import script from "./UserBind.vue?vue&type=script&lang=js&"
export * from "./UserBind.vue?vue&type=script&lang=js&"
import style0 from "./UserBind.vue?vue&type=style&index=0&id=21f3350d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f3350d",
  null
  
)

export default component.exports